export default import.meta.ROLLDOWN_FILE_URL_0rD94NMfS1WHp0id2YoAeg